import {GridItem} from 'platform/foundation';

import {RegistrationNumberGroup} from '../../kit/groups/RegistrationNumberGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function RegistrationDocumentsSubSection() {
  return (
    <VFKit.SubSection data-testid="registration-documents">
      <VFKit.Group data-testid="registration-row" columns={[1, 2, 4]}>
        <GridItem span={[1, 2, 2]}>
          <VFKit.Group data-testid="registration-numbers">
            <RegistrationNumberGroup />
          </VFKit.Group>
        </GridItem>
        <VFKit.ServicedInAuthorizedNetworkChips />
      </VFKit.Group>
      <VFKit.Group data-testid="registration-checkboxes" columns={[1, 2, 4]}>
        <VFKit.IsRegisteredCheckbox />
        <VFKit.HasCocCheckbox />
      </VFKit.Group>
      <VFKit.OtherRecordsTextarea />
    </VFKit.SubSection>
  );
}
